import React from 'react'
import { Link } from 'react-router-dom'
import './not_found.scss'
import { useTranslation } from 'react-i18next'

function NotFound() {
    const { t } = useTranslation('notfound')
    return (
        <div className="not-found">
            <div className="not-found__bg" />
            <div className="not-found__overlay" />
            <div className="not-found__content">
                <span className="not-found__code">404</span>
                <h1>{t('Page not found')}</h1>
                <span className="not-found__rule" />
                <Link to="/" className="not-found__link">{t('Go to start page')}</Link>
            </div>
        </div>
    )
}

export default NotFound
